import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const PptIcon = ({size = {width: 32, height: 40}}: Props) => {
    return (
        <svg width={size.width} height={size.height} viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.59518 10.3571L10.4929 1.57645C10.8672 1.20709 11.3718 1 11.8977 1H28C29.6569 1 31 2.34315 31 4V36C31 37.6569 29.6569 39 28 39H4C2.34315 39 1 37.6569 1 36V11.7806C1 11.2456 1.21437 10.7329 1.59518 10.3571Z'
                stroke='#ED522A'
                strokeWidth='2'
            />
            <path d='M11 2V11C11 11.5523 10.5523 12 10 12H2' stroke='#ED522A' strokeWidth='2' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.8317 25.7059C19.6106 25.0219 20 24.0342 20 22.7428C20 21.5007 19.6343 20.5664 18.903 19.9398C18.1716 19.3133 17.1036 19 15.699 19H12V31H14.4554V26.7319H15.5089C16.9452 26.7319 18.0528 26.3899 18.8317 25.7059ZM15.2634 24.6471H14.4554V21.0848H15.5723C16.2429 21.0848 16.7353 21.2271 17.0495 21.5116C17.3637 21.7962 17.5208 22.2367 17.5208 22.8331C17.5208 23.4241 17.3333 23.8742 16.9584 24.1833C16.5835 24.4925 16.0185 24.6471 15.2634 24.6471Z'
                fill='#ED522A'
            />
        </svg>
    );
};
